export default class DDOption {
    readonly value: string;
    readonly label: string;
    readonly name: string;
    readonly description: string;
    readonly isFixed?: boolean;
    readonly isDisabled?: boolean;
    readonly groupId?: number;
}

export class GroupedOption {
    readonly Id: number;
    readonly label: string;
    readonly options: readonly DDOption[];
}